const API_URL = 'https://pinata-rotator-worker.torweb321.workers.dev/';

// 发布博客（POST /publish）
export async function publishBlog({ content, name }) {
  // 签名等逻辑建议在调用处完成，这里只负责上传
  const res = await fetch(API_URL + 'publish', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ content, name })
  });
  if (!res.ok) throw new Error('发布失败');
  return res.json();
}

// 获取所有博客（分页）
export async function fetchBlogList(page = 1, pageSize = 20) {
  const res = await fetch(API_URL + `list?page=${page}&pageSize=${pageSize}`);
  if (!res.ok) throw new Error('获取博客列表失败');
  return res.json(); // { total, page, pageSize, list: [...] }
}

// 删除博客（通过 CID）
export async function deletePostByCid(cid) {
  const res = await fetch(API_URL + `delete?cid=${cid}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('删除博客失败');
  return res.json();
}

// 通过 CID 获取单篇博客内容（兼容历史逻辑）
export async function fetchPostByCid(cid) {
  // 直接用 ipfs.io 网关获取内容
  const res = await fetch(`https://ipfs.io/ipfs/${cid}`);
  if (!res.ok) throw new Error('获取博客内容失败');
  return res.json();
}
